import { render, staticRenderFns } from "./Compose.Header.vue?vue&type=template&id=4639f202&scoped=true&"
import script from "./Compose.Header.vue?vue&type=script&lang=js&"
export * from "./Compose.Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639f202",
  null
  
)

export default component.exports